export const InventoryTypeEnum = {
    OFMStock: "OFMStock",
    DropShip: "DropShip"
};
export const InventoryLockLevel = 2